<template>
  <div class="home-view">
    <HeroSection />
    <AboutSection />
    <TeamSection />
    <EnterpriseSection />
  </div>
</template>

<script setup>
import HeroSection from '@/components/home/HeroSection.vue'
import AboutSection from '@/components/home/AboutSection.vue'
import TeamSection from '@/components/home/TeamSection.vue'
import EnterpriseSection from '@/components/home/EnterpriseSection.vue'
</script>

<style scoped>
.home-view {
  width: 100%;
  overflow-x: hidden;
}
</style>
